import { forwardRef } from "react";
import { Popover } from "react-bootstrap";
import { OverlayInjectedProps } from "react-bootstrap/esm/Overlay";

interface IPopoverProps extends OverlayInjectedProps {
    tooltipId: string;
    message: string;
    title?: string;
    popoverStyle?: React.CSSProperties;
}
const LobbiePopover = forwardRef((props: IPopoverProps, ref: React.Ref<any>) => {
    const { tooltipId, title, message, style, popoverStyle, ...rest } = props;
    return (
        <Popover id={tooltipId} {...rest} ref={ref} style={{ ...style, ...popoverStyle }}>
            <Popover.Header as="h3">{title || "Details"}</Popover.Header>
            <Popover.Body>{message}</Popover.Body>
        </Popover>
    );
});
export default LobbiePopover;
